import { useEffect, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Toast } from "antd-mobile";
import { UserContext } from 'utils/getContext'
import { getUserInfo } from 'api/api'
import { userType } from "utils/constant";
import { getQueryString } from 'utils/index'

function CheckLogin() {
  const navigate = useNavigate()
  // 获取页面路由之后的所有参数
  const { search } = useLocation()
  // 从参数中获取ticket以及router
  const ticket = getQueryString('trustticket')
  const router = getQueryString('router') || '/'
  // 从上下文获取用户信息
  const { setUserInfo } = useContext(UserContext)
  const { USER, UNIT } = userType

  const handleNavigate = (router) => {
    if (router) {
      navigate(router)
    } else {
      navigate('/home')
    }
  }

  useEffect(() => {
    sessionStorage.setItem('isCheckLogin', true)

    /**登录 */
    const getLogin = (router) => {
      localStorage.setItem('isLogin', true)
      handleNavigate(router)
    }

    /**退出登录 */
    const getLoginOut = (router) => {
      localStorage.setItem('isLogin', false)
      localStorage.removeItem('ticket')
      setUserInfo(null)
      handleNavigate(router)
    }

    /**登录失败 */
    const getLoginFail = () => {
      getLoginOut('/home')
      Toast.show({
        icon: 'fail',
        content: '获取用户信息失败，请刷新页面重试',
      })
    }

    if (search) {
      const isLogin = localStorage.getItem('isLogin')
      if (ticket) {
        getUserInfo(ticket).then((res) => {
          const { data } = res
          if (data) {
            // 处理data，将data转化为所需的格式
            const newData = data.data || data
            const handleType = (type) => {
              switch (type) {
                case "1":
                  return USER
                case "2":
                  return UNIT
                default:
                  return ''
              }
            }
            const returnData = {
              name: newData?.USER_NAME || '', // 用户姓名
              idNum: newData?.USER_IDCARD || '',//用户id
              birthday: newData?.POPULATION_BIRTHDAY || '', // 出生日期
              sex: newData?.POPULATION_SEX || '', // 性别
              grade: newData?.POPULATION_GRADE || '', // 人员等级
              id: newData?.USER_ID || '', // 用户id
              Logins: newData?.USER_LOGINS || '', // 登录次数
              type: handleType(newData?.USER_TYPE),// 用户类型
              ...newData
            }
            setUserInfo(newData ? returnData : null)
            localStorage.setItem("user", JSON.stringify(returnData))
            getLogin(router)
          } else {
            getLoginFail()
          }
        })
      } else {
        if (isLogin) {
          getLogin(router)
        } else {
          getLoginOut(router)
        }
      }
    }
    else {
      getLoginOut(router)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])


  return (
    <>
    </>
  )
}

export { CheckLogin }